import { FC, useState } from 'react';
import { Form, Input, Button, Alert, Typography } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import AuthPage from 'modules/auth/components/AuthPage';
import { Logo } from 'modules/ui';
import config from 'config';

import { requestMagicLink } from '../../api';

const { Title, Paragraph } = Typography;

const MagicLinkPage: FC = () => {
    const { formatMessage, locale } = useIntl();
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (values: { email: string; fullName: string }) => {
        setLoading(true);
        setError(null);
        try {
            await requestMagicLink(values.email, values.fullName, locale);
            setSent(true);
        } catch {
            setError(formatMessage({ id: 'guest.magicLink.error' }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthPage>
            <div style={{ width: '100%', padding: '2rem 1rem 3rem' }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
                    <div style={{  height: 70 }}><Logo /></div>
                </div>

                {sent ? (
                    <Alert
                        type="success"
                        message={formatMessage({ id: 'guest.magicLink.sent.title' })}
                        description={formatMessage({ id: 'guest.magicLink.sent.description' })}
                        showIcon
                        style={{ marginBottom: '1rem' }}
                    />
                ) : (
                    <>
                        <Title level={4} style={{ marginBottom: '0.5rem' }}>
                            <FormattedMessage id="guest.magicLink.title" />
                        </Title>
                        <Paragraph type="secondary" style={{ marginBottom: '1.5rem' }}>
                            <FormattedMessage id="guest.magicLink.subtitle" />
                        </Paragraph>

                        {error && (
                            <Alert type="error" message={error} showIcon style={{ marginBottom: '1rem' }} />
                        )}

                        <Form layout="vertical" onFinish={handleSubmit}>
                            <Form.Item
                                name="fullName"
                                label={formatMessage({ id: 'guest.magicLink.fullName' })}
                                rules={[{ required: true, message: formatMessage({ id: 'form.validation.required.fullName' }) }]}
                            >
                                <Input size="large" placeholder={formatMessage({ id: 'guest.magicLink.fullName' })} />
                            </Form.Item>

                            <Form.Item
                                name="email"
                                label={formatMessage({ id: 'auth.email' })}
                                rules={[{ required: true, type: 'email', message: formatMessage({ id: 'form.validation.required.email' }) }]}
                            >
                                <Input type="email" size="large" placeholder={formatMessage({ id: 'auth.email' })} />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    loading={loading}
                                    disabled={loading}
                                    style={{ width: '100%', marginTop: '1rem' }}
                                >
                                    <FormattedMessage id="guest.magicLink.submit" />
                                </Button>
                            </Form.Item>
                        </Form>
                    </>
                )}

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                    <Link to={config.routes.login}>
                        <FormattedMessage id="guest.magicLink.backToLogin" />
                    </Link>
                </div>
            </div>
        </AuthPage>
    );
};

export default MagicLinkPage;
